<div class="splash" *ngIf="showSplash">
  <img class="logo" src="../../../assets/img/anyo-logo.svg" />
  <div class="linear-activity">
    <div class="indeterminate"></div>
  </div>
  <img class="image" src="assets/img/loader-background.png" />
</div>
